/* eslint-disable */
import { Link } from "react-router-dom";

import Footer from "Components/Common/Footer/Footer";
import Header from "Components/Common/Header/Header";
import EventListBody from "Components/EventList/EventListBody/EventListBody";

const EventList = () => {
  return (
    <>
      <Header moduleName={"event"} />
      <EventListBody />
      <Footer />
    </>
  );
};

export default EventList;
